import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { GrFormViewHide, GrFormView } from "react-icons/gr";
import KG_B from "../../../../images/KG_B.png";
import KG_W from "../../../../images/KG_W.png";

import "./chessRole.css";
const ChessRole = props => {
	const userState = useSelector(state => state.user);
	let [spectator, setSpectator] = useState(false);
	let [selection, setSelection] = useState("BLACK PIECE");
	let [error, setError] = useState("");
	let [errorVisible, setErrorVisible] = useState(false);

	useEffect(() => {
		handleError();
	}, [userState.role]);

	function handleError(selectedRole) {
		// White is still available && selected piece is white
		if (userState.role !== "WHITE ALREADY TAKEN" && selectedRole === "white") props.handleRole("white");
		// Wlack is still available && selected piece is black
		else if (userState.role !== "BLACK ALREADY TAKEN" && selectedRole === "black") props.handleRole("black");
		// Show Error message if black role is already taken
		else if (userState.role === "BLACK ALREADY TAKEN") {
			setError("BLACK ALREADY TAKEN");
			setErrorVisible(true);
		}
		// Show Error message if white role is already taken
		else if (userState.role === "WHITE ALREADY TAKEN") {
			setError("WHITE ALREADY TAKEN");
			setErrorVisible(true);
		}
	}

	return (
		<div className={props.chessRoleVisible ? "chess-role-visible" : "chess-role-hidden"}>
			<div className="text-container">
				<h5 className="continue">{"CONTINUE AS"}</h5>
				<h1 className="selection">{selection}</h1>
				<p className={errorVisible ? "error-visible" : "error-hidden"}>{error}</p>
			</div>

			<div style={{ width: "35vw" }} />
			<img
				src={KG_B}
				className="icon"
				alt="Black King"
				onClick={() => handleError("black")}
				onMouseEnter={() => setSelection("BLACK PIECE")}
				onMouseLeave={() => setErrorVisible(false)}
			/>
			<img
				src={KG_W}
				className="icon"
				alt="White King"
				onClick={() => handleError("white")}
				onMouseEnter={() => setSelection("WHITE PIECE")}
				onMouseLeave={() => setErrorVisible(false)}
			/>
			<div
				onClick={() => props.handleRole("viewer")}
				onMouseEnter={() => {
					setSelection("SPECTATOR");
					setSpectator(true);
				}}
				onMouseLeave={() => setSpectator(false)}
			>
				{spectator ? <GrFormView className="spectator-icon" /> : <GrFormViewHide className="spectator-icon" />}
			</div>
		</div>
	);
};

export default ChessRole;
